"use client";

import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import { chatAPI } from "@/lib/api";
import { getStoredSource } from "@/lib/sourceTracking";

/** Tells the patient, before they send, that a study team also gets their data (Rudi ADR 0144). */
export function ReferralNotice() {
  const [notice, setNotice] = useState<string | null>(null);

  useEffect(() => {
    let current = true;
    void chatAPI.getReferralTarget(getStoredSource()).then((target) => {
      if (current) setNotice(target.notice ?? null);
    });
    return () => {
      current = false;
    };
  }, []);

  if (!notice) return null;
  return (
    <p className="flex items-start gap-2 px-4 pb-3 text-xs text-muted-foreground">
      <Info className="h-3.5 w-3.5 shrink-0 mt-0.5" />
      <span>{notice}</span>
    </p>
  );
}
